const topics = [
  { label: '91国产高清视频', heat: '128.6万', hot: true },
  { label: '超清视频在线观看', heat: '96.3万', hot: true },
  { label: '高清影视在线', heat: '87.1万', hot: false },
  { label: '91高清视频在线', heat: '203.7万', hot: true },
  { label: '每日更新推荐', heat: '65.4万', hot: false },
  { label: '国产精选合集', heat: '54.2万', hot: false },
  { label: '流畅播放体验', heat: '43.8万', hot: false },
  { label: '移动端观影', heat: '38.9万', hot: false },
  { label: '热门视频排行', heat: '72.5万', hot: true },
];

export default function Topics() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            当前平台最受关注的话题标签，点击探索您感兴趣的内容方向
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, idx) => (
            <div
              key={idx}
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-300 whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-100 border-primary-200/60 hover:bg-primary-200/60'
                  : 'bg-background-50 border-background-200/70 hover:border-primary-200/50'
              }`}
            >
              {topic.hot && (
                <i className="ri-fire-line text-primary-500 text-sm"></i>
              )}
              <span className={`text-sm font-medium ${topic.hot ? 'text-primary-700' : 'text-foreground-700'}`}>
                {topic.label}
              </span>
              <span className="text-xs text-foreground-400">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}